<template>
  <div class="tab-group">
    <nav class="tab-group__list">
      <LinkButton
        v-for="(tab, index) in tabs"
        :key="index"
        tag="button"
        type="button"
        no-styling
        class="tab-group__item"
        :class="{ 'tab-group__item--active': activeEntry === index }"
        @click.stop="setActive(index)"
      >
        {{ tab.label }}
      </LinkButton>
    </nav>
    <div
      :class="tabGroupContentClass"
      class="tab-group__content"
    >
      <template v-if="!hasLinks">
        <div
          v-for="(tab, index) in tabs"
          :key="index"
        >
          <div
            v-show="isActive(index, tab)"
            :class="tabEntryClasses(tab)"
            class="tab-group__content"
          >
            <slot
              :label="tab.label"
              :name="tab.name"
            />
          </div>
        </div>
      </template>
      <template v-else>
        <div>
          <slot />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { LinkButton } from '@i22-td-smarthome/component-library';

export default {
  name: 'TabGroup',
  components: { LinkButton },
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
    active: {
      type: Number,
      default: 0,
    },
    offer: {
      type: Object,
      default: () => {},
    },
    hasLinks: {
      type: Boolean,
      default: false,
    },
    hasPadding: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeEntry: this.active,
    };
  },
  computed: {
    browserUrl() {
      return this.$config.public.baseUrl + this.$route.fullPath;
    },
    tabGroupContentClass() {
      return this.hasPadding ? 'tab-group__content--has-padding' : '';
    },
  },
  methods: {
    setActive(index) {
      if (this.activeEntry === index) return;
      this.activeEntry = index;
    },
    isActive(index, tab) {
      if (this.hasLinks) {
        return tab.name === this.activeEntry;
      }
      return index === this.activeEntry;
    },
    tabEntryClasses(tab) {
      const selector = `tab-group__content__${tab.name}`;
      const status = this.isActive(tab) ? 'active' : 'inactive';
      return [status, selector];
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.tab-group {
  &__list {
    width: 100%;
    border-bottom: 1px solid color(grey, 25000);
    text-align: center;
    white-space: nowrap;
    overflow-y: hidden;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    margin-bottom: $grid-base * 2;
  }

  &__item {
    display: inline-block;
    font-weight: 700;
    text-transform: uppercase;
    padding: 5px $grid-base 8px $grid-base;
    border-bottom: 4px solid transparent;
    transition: border 0.125s ease-out;
    border-radius: 0;
    color: currentColor;

    &:hover,
    &--active {
      border-bottom-color: currentColor;
    }

    &--active {
      color: var(--color-primary);
    }

    &:focus-visible {
      outline-offset: -2px;
    }
  }

  &__headline {
    margin-top: 7px;
  }

  &__content {
    margin-bottom: 3 * $grid-base;

    &--has-padding {
      padding-top: 18px;
      @include mq($mq-sm) {
        padding-top: 55px;
      }
    }
  }
}
</style>
